import { render } from "./SecurityRoles.vue?vue&type=template&id=70dfdec4&ts=true"
import script from "./SecurityRoles.vue?vue&type=script&lang=ts"
export * from "./SecurityRoles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__